import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Decimation,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  ScatterController,
  TimeScale,
  TimeSeriesScale,
  Title,
  Tooltip,
} from 'chart.js';
import 'chartjs-adapter-moment';

/**
 * Chart.js controllers/scales shared by every chart in the app.
 *
 * This used to live in GlobalLayout, which gatsby-browser and gatsby-ssr import
 * directly. That put chart.js and its moment adapter in the shared app bundle on
 * every route, including the ones with no chart on them. Importing this module
 * for its side effect from the components that actually render a chart keeps it
 * in their chunks instead.
 *
 * Chart.register is idempotent, so importing this from several components is fine.
 *
 * RadarChart registers its own set (RadialLinearScale, Filler, Legend) and does
 * not need this one.
 */
Chart.register(
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  LineController,
  ScatterController,
  CategoryScale,
  LinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Title,
  Tooltip
);
